import Block from '@components/Layout/Block';
import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import {
  Body,
  Container,
  ContentContainer,
  ContentWrapper,
  Eyebrow,
  GridImageContainer,
  GridTopContainer,
  Header,
  IndividualContainer,
} from '@components/ThreeColumn/styles';
import evAPI from '@util/api/ev';
import { getImage, getName, getTitleLeadership } from '@util/api/listingAdvisors';
import { FC, useEffect, useState } from 'react';

export interface ThreeColumnLeadershipProps {
  header: string;
}

const ThreeColumnLeadership: FC<ThreeColumnLeadershipProps> = ({ header }) => {
  const api = new evAPI();
  const [leadership, setLeadership] = useState<any[]>([]);
  const fetchLeadership = async () => {
    try {
      const params = {
        offset: 0,
        limit: 99,
        specializations: 'leadership',
      };
      const res = await api.listAdvisors(params);
      const mapResults = await res?.records?.map((advisor) => {
        return {
          name: getName(advisor),
          description: getTitleLeadership(advisor),
          img: getImage(advisor),
        };
      });
      setLeadership(mapResults);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchLeadership();
  }, []);

  return (
    <Block narrow>
      <Container>
        <GridTopContainer>
          <ContentContainer>{header && <Header>{header}</Header>}</ContentContainer>
        </GridTopContainer>
        <VerticalLineSeparator />
        <GridImageContainer>
          {leadership &&
            leadership.map((obj, index) => (
              <IndividualContainer key={index}>
                <div>
                  <AdvisorHeadshot img={obj.img} alt_text={obj.name} />
                </div>
                <ContentWrapper>
                  <Eyebrow>{obj.name}</Eyebrow>
                  <Body>{obj.description}</Body>
                </ContentWrapper>
              </IndividualContainer>
            ))}
        </GridImageContainer>
      </Container>
    </Block>
  );
};

export default ThreeColumnLeadership;
